import { Component, Inject } from '@angular/core';
import { TOCModel } from '../../models/TOCModel';
import { FormControl, Validators } from '@angular/forms';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-toc-add-edit',
  templateUrl: './toc-add-edit.component.html',
  styleUrl: './toc-add-edit.component.css'
})
export class TocAddEditComponent {
  submitted: boolean = false;
  toc: TOCModel = new TOCModel();
  name = new FormControl('', [Validators.required]);
  code = new FormControl('', [Validators.required]);

  constructor(public _restAPI: RestAPIService, private toast: ToastService, public dialogRef: MatDialogRef<TocAddEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any){
    this._restAPI.loading  = false;
    this.toc = JSON.parse(JSON.stringify(data.tocModel));
    localStorage["applyTOCFilterValue"] = 'true';
  }

  async ngOnInit(){
    if(this.toc.id) {
      this.getTOCById(this.toc.id)
    }
  }

  getTOCById(id: string) {
    this._restAPI.loading  = true;
    this._restAPI.get<string>(environment.apiURL + 'api/trainoperatingcompany/'+id).subscribe({
        next: (data) => {
            this._restAPI.loading  = false;
            this.previewUrl = data.fileBase64Content;
        },
        error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
    });
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  async saveTOC() {
    if(!this.name.invalid && !this.code.invalid){
      this._restAPI.loading  = true;
      let formData = new FormData();
      formData.append('name', this.toc.name!);
      formData.append('code', this.toc.code!);
      if (this.toc.id != null && this.toc.id.length > 0) {
        if(this.selectedFile){
          formData.append('logo', this.selectedFile);
        }
        this._restAPI.putFormData<string>(environment.apiURL + 'api/trainoperatingcompany/edit/' + this.toc.id, formData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Train Operating company has been updated successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
      else {
        if(!this.selectedFile){
          this._restAPI.loading  = false;
          this.toast.error("Please select logo.");
          return;
        }
        formData.append('logo', this.selectedFile);
        this._restAPI.postFormData<string>(environment.apiURL + 'api/trainoperatingcompany/add', formData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Train Operating company has been added successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
    }
  }

  // drage and drop 
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const validTypes = ['image/jpeg', 'image/png'];
    const file = input.files[0];
    if (!validTypes.includes(file.type)){
      this.toast.error("Invalid Format");
      return;
    }

    this.selectedFile = file;

    const reader = new FileReader();
    reader.onload = () => this.previewUrl = reader.result;
    reader.readAsDataURL(this.selectedFile);
  }
}
